// @flow
/* eslint-disable react/style-prop-object */
import React from 'react';
import { FormattedNumber } from 'react-intl';

export default function Percent({ style, ...rest }: *) {
  return <FormattedNumber style="percent" {...rest} />;
}
